import React, { Fragment, useContext, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Badge from '@material-ui/core/Badge';

import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getIsShowCalendarMoreTileBatch } from '../../common/calendarHelper';
import AfitdTypography from '../../common/elemental/AfitdTypography';
import InterviewListPopoverWeekly from './InterviewListPopoverWeekly';

import { format } from 'date-fns';

const styles = theme => ({
    root: {
        padding: '9px 8px 9px 8px',
        borderRadius: '10px',
        backgroundColor: '#F7F7FA',
        '&:hover': {
            backgroundColor: 'rgba(125, 46, 2, 0.1)',
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        textOverflow: 'ellipsis',
    },
    badge: { width: '100%' },
    moreContainer: { flexGrow: 1 },
});

const getDefns = params => {
    const { props, dt, isShowBatch, interviewListPopoverOpen, interviewList, interviewListPopoverAnchorEl } = params;
    const { setInterviewListPopoverOpen, setSelectedDate, setInterviewListPopoverAnchorEl } = params;
    const { remainingCount, classes } = props;

    const interviewListPopoverDayOfWeek = format(dt, 'E');
    const interviewListPopoverDayOfMonth = format(dt, 'd');

    let defns = {
        root: {
            onClick: handleClickMoreInterviewsBlock.bind(null, setInterviewListPopoverAnchorEl, setInterviewListPopoverOpen, setSelectedDate),
        },
        moreText: {
            variant: 'body2',
            clsLightBold: true,
            value: `${remainingCount} interview${remainingCount > 1 ? 's' : ''}`,
        },
        interviewListPopover: {
            anchorEl: interviewListPopoverAnchorEl,
            open: interviewListPopoverOpen,
            interviewList,
            dayOfWeek: interviewListPopoverDayOfWeek,
            dayOfMonth: interviewListPopoverDayOfMonth,
            setInterviewListPopoverOpen,
            onClose: handleCloseInterviewListPopover.bind(null, setInterviewListPopoverOpen),
        },
        badge: {
            color: 'primary',
            badgeContent: ' ',
            variant: 'dot',
            invisible: !isShowBatch,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const handleClickMoreInterviewsBlock = (setInterviewListPopoverAnchorEl, setInterviewListPopoverOpen, setSelectedDate, evt) => {
    evt.preventDefault();
    setInterviewListPopoverAnchorEl(evt.target);
    setInterviewListPopoverOpen(true);
    setSelectedDate();
};

const handleCloseInterviewListPopover = setInterviewListPopoverOpen => {
    setInterviewListPopoverOpen(false);
};

const MoreInterviewsBlockWeekly = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    const context = useContext(LayoutContext);
    const { setSelectedDate, dashboardData } = context;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    const [interviewListPopoverAnchorEl, setInterviewListPopoverAnchorEl] = useState({});
    const [interviewListPopoverInfo, setInterviewListPopoverInfo] = useState({});
    const [interviewListPopoverOpen, setInterviewListPopoverOpen] = useState(false);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { isHidden, interviewList, dt, height } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const isShowBatch = getIsShowCalendarMoreTileBatch({ interviewList, dashboardData });

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({
        props,
        dt,
        isShowBatch,
        interviewListPopoverInfo,
        setInterviewListPopoverInfo,
        interviewListPopoverOpen,
        setInterviewListPopoverOpen,
        interviewListPopoverAnchorEl,
        setInterviewListPopoverAnchorEl,
        setSelectedDate,
        interviewList,
    });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return isHidden ? null : (
        <Fragment>
            <Badge {...defns.badge}>
                <ButtonBase {...defns.root} style={{ height: `${height}px` }}>
                    <AfitdTypography {...defns.moreText} />
                </ButtonBase>
            </Badge>
            {interviewListPopoverOpen && <InterviewListPopoverWeekly {...defns.interviewListPopover} />}
        </Fragment>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(MoreInterviewsBlockWeekly);
